export default __webpack_public_path__ + "images/bb36f2dc8eeefbac1d7fa8458a0ad494.png";